require('ta-semantic-ui/semantic/dist/components/reset.css');
require('ta-semantic-ui/semantic/dist/components/site.css');
require('ta-semantic-ui/semantic/dist/components/container.css');
require('styles/App.css');

import React from 'react';
import TrumpHeader from '../trump-header/TrumpHeader.component';
import GoogleComponent from '../googleData/GoogleData.component';
import Tracking from 'ta-react-tracking';


class AppComponent extends React.Component {
  render() {
    return (
      <div className='index infographic'>
        <Tracking/>
        <TrumpHeader />
        <GoogleComponent />
      </div>
    );
  }
}

AppComponent.defaultProps = {};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/main/Main.js